import { render, staticRenderFns } from "./NolaNovel.vue?vue&type=template&id=0a1de5e9&scoped=true"
import script from "./NolaNovel.vue?vue&type=script&lang=ts"
export * from "./NolaNovel.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovel.vue?vue&type=style&index=0&id=0a1de5e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1de5e9",
  null
  
)

export default component.exports